module.exports = __webpack_public_path__ + "assets/security-white.fb915e59.svg";